module.exports = "/_next/static/images/886a22576842f49e957b7d10e6317ad6-join-us-xs-2x.png.webp";